import { useQuery } from "@tanstack/react-query";
import { sensorsApi } from "@/api/sensors";

export function useSensors(deviceId: string | undefined, hours = 48) {
  return useQuery({
    queryKey: ["sensors", deviceId, hours],
    queryFn: () => sensorsApi.list(deviceId!, hours),
    enabled: !!deviceId,
    refetchInterval: 60_000,
  });
}
